import { useWindowWidth } from '@/service/hooks/useWindowWidth';
import { ECartActionType } from '@/service/state/Cart/domain';
import { useCartStore } from '@/service/state/Cart/useCartStore';
import { usePartnerStore } from '@/service/state/Partner/usePartnerStore';
import { cn } from '@/service/utils/cn';
import { IconButton } from '@/ui/common/Buttons/IconButton';
import { Drawer } from '@/ui/common/Drawer/Drawer';
import { CloseIcon } from '@/ui/common/Icons/CloseIcon';
import { ReactNode, useEffect } from 'react';

type TTicketsContainerProps = {
    children: ReactNode;
    caption?: ReactNode;
    widthFull?: boolean;
    onClose: (skipConfirmation?: boolean) => void;
};

const DesktopWrapper = ({
    children,
    onClose,
    widthFull,
}: {
    children: ReactNode;
    onClose: () => void;
    widthFull?: boolean;
}) => {
    const { isLightframePage } = usePartnerStore();

    return (
        <div
            data-test-id="calendar-desktop-container"
            className="md:fixed md:bottom-0 md:left-0 md:right-0 md:top-0 md:z-50 md:flex md:cursor-pointer md:items-center md:justify-center md:bg-black md:bg-opacity-50 md:pt-16"
            onClick={onClose}
            id="availability"
        >
            <div
                className={cn(
                    'relative mt-8 max-w-[810px] rounded-2xl bg-white dark:bg-blue-main md:absolute md:mt-0 md:cursor-auto',
                    isLightframePage ? 'md:max-h-[calc(90vh_-_75px)]' : 'md:max-h-[90vh]',
                    widthFull && 'w-full'
                )}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <IconButton
                    icon={<CloseIcon className="h-9 w-9 bg-ash dark:bg-blue-dark" />}
                    className="absolute right-3 top-3 z-50 hidden rounded-3xl hover:shadow-lightCard dark:hover:shadow-dark md:block"
                    onClick={onClose}
                />
                {children}
            </div>
        </div>
    );
};

export const TicketsContainer = ({ children, onClose, widthFull }: TTicketsContainerProps) => {
    const { mobile } = useWindowWidth();
    const { success, clearSuccess } = useCartStore();

    useEffect(() => {
        if (success.actionType === ECartActionType.ADD_ITEM_TO_CART && success.message) {
            onClose(true);
            clearSuccess(ECartActionType.ADD_ITEM_TO_CART);
        }
    }, [clearSuccess, onClose, success.actionType, success.message]);

    return (
        <>
            {mobile ? (
                <Drawer onClose={() => onClose()} open draggable caption fullHeightByDefault>
                    {children}
                </Drawer>
            ) : (
                <DesktopWrapper onClose={() => onClose()} widthFull={widthFull}>
                    {children}
                </DesktopWrapper>
            )}
        </>
    );
};
